import { isFieldExpression, expressionToList } from 'automation-ui-formula-editor/formula-editor/grammar/expressionUtils';
// @ts-expect-error untyped module
import { parse as hubLParse } from 'automation-ui-formula-editor/formula-editor/grammar/hubL/hubLParser';
import memoize from 'transmute/memoize';
export const isDataToken = memoize(maybeDataToken => {
  if (!maybeDataToken) {
    return false;
  }
  try {
    const expressionList = expressionToList(hubLParse(maybeDataToken));
    return expressionList.length === 1 && isFieldExpression(expressionList[0]);
  } catch (_unused) {
    return false;
  }
});